import React, { useEffect, useRef, useState } from 'react'
import AppNavbar from './Navbar/AppNavbar'
import Footer from './Navbar/Footer'
import { useDispatch } from 'react-redux'
import {
  Users,
  Sparkles,
  Search,
  Clock3,
} from "lucide-react";
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import { setAiModal } from './redux/action';

function OpenAiPage() {
  const navigate = useNavigate();

  const containerRef = useRef();

  const [response, setResponse] = useState([]);
  const [filterApplied, setFilterApplied] = useState([]);
  const [countVal, setCountval] = useState();
  let dispatch = useDispatch();

  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     if (event.data.type === "NOCTRA_DATA") {
  //       console.log("Received from Noctra:", event.data);

  //       let result = event.data.results;
  //       if (result.intent === "needs_clarification" || result.intent === "count_request" || result.intent === "search_request") {
  //         setFilterApplied(result.filters_detected)
  //       }
  //       if (result.intent === "count_request") {
  //         setCountval(result.count)
  //       }
  //       setResponse((prev) => [...prev, event.data.results]);
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);

  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, [dispatch]); 

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "NOCTRA_DATA") {
        console.log("Received from Noctra:", event.data);

        const result = event.data.results;

        // Save session_id as soon as it arrives
        if (result?.session_id) {
          sessionStorage.setItem("ai_session_id", result.session_id);
          console.log("AI SESSION ID from plugin =>", result.session_id);
        }

        if (
          result.intent === "needs_clarification" ||
          result.intent === "count_request" ||
          result.intent === "search_request"
        ) {
          const rawFilters = result.filters_detected || {};

          // Always convert to a clean array of { label, value }
          let normalized = [];

          if (Array.isArray(rawFilters)) {
            // Already array of {key, label, value}
            normalized = rawFilters.map((f) => ({
              label: f.label || f.key || "Filter",
              value: Array.isArray(f.value)
                ? f.value.join(", ")
                : typeof f.value === "object"
                  ? JSON.stringify(f.value)
                  : String(f.value ?? ""),
            }));
          } else {
            // Object form: { jobTitle: [...], seniority: [...] }
            normalized = Object.entries(rawFilters).map(([key, value]) => ({
              label: key,
              value: Array.isArray(value)
                ? value.join(", ")
                : typeof value === "object"
                  ? JSON.stringify(value)
                  : String(value ?? ""),
            }));
          }

          setFilterApplied(normalized);
        }

        if (result.intent === "count_request") {
          setCountval(result.count);
        }

        setResponse((prev) => [...prev, result]);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [dispatch]);


  useEffect(() => {
    requestAnimationFrame(() => {
      containerRef.current?.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    });
  }, [response]);

  if (response.length === 0) {
    return (
      <div className='page-layout'>
        <AppNavbar />
        <div className="page-content">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              minHeight: "100vh",
              background:
                "linear-gradient(135deg, #f8f5f8 0%, #f3eef3 100%)",
            }}
          >
            <div
              className="text-center p-3"
              style={{
                width: "100%",
                maxWidth: "700px",
              }}
            >
              <div className="position-relative mb-4">
                <div className="ai-glow-circle"></div>

                <div className="ai-main-icon">
                  <Sparkles size={42} />
                </div>
              </div>

              <h1
                className="fw-bold mb-3"
                style={{
                  color: "#4F0341",
                  fontSize: "2rem",
                }}
              >
                AI Assistant Connected Successfully
              </h1>

              <p
                className="text-muted mb-3"
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.8",
                }}
              >
                Your Leadmerge platform is now connected with
                Learmerge AI.
                <br />
                Start searching from the AI application to receive
                intelligent lead insights and contact data here in
                real-time.
              </p>

              {/* Info Cards */}
              <div className="row g-4 mt-1">
                <div className="col-md-4">
                  <div className="ai-info-card">
                    <Search size={26} />
                    <h6>AI Search</h6>
                    <p>
                      Perform searches directly from the AI plugin
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="ai-info-card">
                    <Users size={26} />
                    <h6>Lead Sync</h6>
                    <p>
                      Lead data will appear instantly inside
                      Leadmerge
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="ai-info-card">
                    <Sparkles size={26} />
                    <h6>AI Insights</h6>
                    <p>
                      Get smart targeting suggestions and
                      recommendations
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <div className="typing-loader mx-auto mb-3">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>

                <p
                  className="mb-0"
                  style={{
                    color: "#7B1E65",
                    fontWeight: "600",
                  }}
                >
                  Waiting for AI search data...
                </p>
              </div>

              <style jsx>{`
              .ai-main-icon {
                width: 100px;
                height: 100px;
                border-radius: 30px;
                background: linear-gradient(
                  135deg,
                  #4f0341,
                  #7b1e65
                );
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: auto;
                position: relative;
                z-index: 2;
                box-shadow: 0 15px 40px rgba(79, 3, 65, 0.25);
                animation: float 3s ease-in-out infinite;
              }

              .ai-glow-circle {
                position: absolute;
                width: 160px;
                height: 160px;
                background: rgba(123, 30, 101, 0.12);
                border-radius: 50%;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                animation: pulse 2.5s infinite;
              }

              .ai-info-card {
                background: white;
                padding: 28px 20px;
                border-radius: 22px;
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
                height: 100%;
                transition: 0.3s;
              }

              .ai-info-card:hover {
                transform: translateY(-4px);
              }

              .ai-info-card svg {
                color: #4f0341;
                margin-bottom: 14px;
              }

              .ai-info-card h6 {
                font-weight: 700;
                margin-bottom: 10px;
              }

              .ai-info-card p {
                color: #777;
                font-size: 14px;
                margin-bottom: 0;
                line-height: 1.6;
              }

              .typing-loader {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
              }

              .typing-loader span {
                width: 12px;
                height: 12px;
                background: #7b1e65;
                border-radius: 50%;
                animation: bounce 1.4s infinite ease-in-out both;
              }

              .typing-loader span:nth-child(1) {
                animation-delay: -0.32s;
              }

              .typing-loader span:nth-child(2) {
                animation-delay: -0.16s;
              }

              @keyframes bounce {
                0%,
                80%,
                100% {
                  transform: scale(0);
                }

                40% {
                  transform: scale(1);
                }
              }

              @keyframes pulse {
                0% {
                  transform: translate(-50%, -50%) scale(1);
                  opacity: 1;
                }

                100% {
                  transform: translate(-50%, -50%) scale(1.4);
                  opacity: 0;
                }
              }

              @keyframes float {
                0%,
                100% {
                  transform: translateY(0px);
                }

                50% {
                  transform: translateY(-10px);
                }
              }
            `}</style>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // region function call for navigate and view result 
  // const viewSearchResult = () => {
  //   let lastResponse = response[response.length - 1]

  //   console.log(lastResponse, "lastResponse")

  //   let filters_detected = lastResponse?.filters_detected

  //   let locations = "";
  //   let contact_level = "";
  //   let job_functions = "";
  //   let job_titles = "";
  //   let companyNames = "";
  //   let companySize = "";
  //   let revenueVal = "";
  //   let Industryval = "";
  //   let SICCode = "";
  //   let techologyNames = "";
  //   let zip_codes = "";
  //   let emailStatus = "";
  //   let phoneStatus = "";

  //   filters_detected.forEach(({ key, value }) => {
  //     switch (key) {
  //       case "organization_locations":
  //       case "person_locations":
  //         locations += value + ", ";
  //         break;

  //       case "person_seniorities":
  //         contact_level += value + ", ";
  //         break;

  //       case "person_functions":
  //         job_functions += value + ", ";
  //         break;

  //       case "person_titles":
  //         job_titles += value + ", ";
  //         break;

  //       case "organization_names":
  //         companyNames += value + ", ";
  //         break;

  //       case "organization_num_employees_ranges":
  //         companySize += value + ", ";
  //         break;

  //       case "organization_revenue_ranges":
  //         revenueVal += value + ", ";
  //         break;

  //       case "organization_industries":
  //         Industryval += value + ", ";
  //         break;

  //       case "organization_sic_codes":
  //         SICCode += value + ", ";
  //         break;

  //       case "organization_technologies":
  //         techologyNames += value + ", ";
  //         break;

  //       case "person_zip_codes":
  //       case "organization_zip_codes":
  //         zip_codes += value + ", ";
  //         break;

  //       case "has_email":
  //         emailStatus = value;
  //         break;

  //       case "has_phone":
  //         phoneStatus = value;
  //         break;

  //       default:
  //         break;
  //     }
  //   });

  //   locations = locations && `Location: ${locations.replace(/,\s*$/, "")}`;
  //   contact_level = contact_level && `Seniorities: ${contact_level.replace(/,\s*$/, "")}`;
  //   job_functions = job_functions && `Job Functions: ${job_functions.replace(/,\s*$/, "")}`;
  //   job_titles = job_titles && `Titles: ${job_titles.replace(/,\s*$/, "")}`;
  //   companyNames = companyNames && `Companies: ${companyNames.replace(/,\s*$/, "")}`;
  //   companySize = companySize && `Company Size: ${companySize.replace(/,\s*$/, "")}`;
  //   revenueVal = revenueVal && `Revenue: ${revenueVal.replace(/,\s*$/, "")}`;
  //   Industryval = Industryval && `Industries: ${Industryval.replace(/,\s*$/, "")}`;
  //   SICCode = SICCode && `SIC Codes: ${SICCode.replace(/,\s*$/, "")}`;
  //   techologyNames = techologyNames && `Technologies: ${techologyNames.replace(/,\s*$/, "")}`;
  //   zip_codes = zip_codes && `Zip Code: ${zip_codes.replace(/,\s*$/, "")}`;
  //   emailStatus = emailStatus && `Having Email: ${emailStatus}`;
  //   phoneStatus = phoneStatus && `Having Phone: ${phoneStatus}`;

  //   const prompt_ = [
  //     "Get contacts for below criteria",
  //     locations,
  //     contact_level,
  //     job_functions,
  //     job_titles,
  //     companyNames,
  //     companySize,
  //     revenueVal,
  //     Industryval,
  //     SICCode,
  //     techologyNames,
  //     zip_codes,
  //     emailStatus,
  //     phoneStatus
  //   ]
  //     .filter(Boolean)
  //     .join("\n");

  //   console.log(prompt_);
  //   let query = { query: prompt_ }
  //   const secret = "lm_data_param";
  //   const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(query), secret).toString();
  //   dispatch(setAiModal(false))
  //   navigate(`/contact-filter?data=${encodeURIComponent(ciphertext)}`);
  // } 

  // const viewSearchResult = () => {
  //   const lastResponse = response[response.length - 1] || {};
  //   console.log("lastResponse =>", lastResponse);

  //   // 1. Get the real session_id
  //   //    (from the last AI response or from sessionStorage)
  //   const sessionId =
  //     lastResponse?.session_id ||
  //     lastResponse?.sessionId ||
  //     sessionStorage.getItem("ai_session_id") ||
  //     null;

  //   // 2. Get the real filters object (NOT an array)
  //   const filters = lastResponse?.filters_detected || {};

  //   // 3. Build a proper prompt from the actual keys the AI returns
  //   const parts = ["Get contacts for below criteria"];

  //   if (filters.jobTitle?.length) {
  //     parts.push(`Titles: ${filters.jobTitle.join(", ")}`);
  //   }

  //   if (filters.seniority?.length) {
  //     parts.push(`Seniorities: ${filters.seniority.join(", ")}`);
  //   }

  //   // Location (city / state / country)
  //   const locationParts = [
  //     ...(filters.city || []),
  //     ...(filters.state || []),
  //     ...(filters.country || []),
  //   ];
  //   if (locationParts.length > 0) {
  //     parts.push(`Location: ${locationParts.join(", ")}`);
  //   }

  //   if (filters.skills?.length) {
  //     parts.push(`Skills: ${filters.skills.join(", ")}`);
  //   }

  //   // Company name (support both possible keys)
  //   const companies = filters.companyName || filters.organization_names;
  //   if (companies) {
  //     parts.push(
  //       `Companies: ${Array.isArray(companies) ? companies.join(", ") : companies}`
  //     );
  //   }

  //   // Company size
  //   const companySize =
  //     filters.companySize || filters.organization_num_employees_ranges;
  //   if (companySize) {
  //     parts.push(
  //       `Company Size: ${Array.isArray(companySize) ? companySize.join(", ") : companySize}`
  //     );
  //   }

  //   // Industry
  //   const industries = filters.industry || filters.organization_industries;
  //   if (industries) {
  //     parts.push(
  //       `Industries: ${Array.isArray(industries) ? industries.join(", ") : industries}`
  //     );
  //   }

  //   // Email / Phone availability
  //   if (filters.hasEmail !== undefined) {
  //     parts.push(`Having Email: ${filters.hasEmail}`);
  //   }
  //   if (filters.hasPhone !== undefined) {
  //     parts.push(`Having Phone: ${filters.hasPhone}`);
  //   }

  //   const prompt_ = parts.filter(Boolean).join("\n");

  //   console.log("Built prompt =>", prompt_);
  //   console.log("Using session_id =>", sessionId);

  //   // 4. Pass BOTH prompt and session_id
  //   const query = {
  //     query: prompt_,
  //     session_id: sessionId, // ← critical
  //   };

  //   const secret = "lm_data_param";
  //   const ciphertext = CryptoJS.AES.encrypt(
  //     JSON.stringify(query),
  //     secret
  //   ).toString();

  //   // Also keep the session in sessionStorage for ContactFilterCategories
  //   if (sessionId) {
  //     sessionStorage.setItem("ai_session_id", sessionId);
  //   }

  //   // Close AI modal and navigate
  //   dispatch(setAiModal(false));
  //   navigate(`/contact-filter?data=${encodeURIComponent(ciphertext)}`);
  // }; 

  const viewSearchResult = () => {
    const lastResponse = response[response.length - 1] || {};
    console.log("lastResponse =>", lastResponse);

    // 1. Session ID
    const sessionId =
      lastResponse?.session_id ||
      lastResponse?.sessionId ||
      sessionStorage.getItem("ai_session_id") ||
      null;

    // 2. Get filters (can be object OR array)
    let rawFilters =
      lastResponse.filters_detected ||
      lastResponse.primary_filter ||
      lastResponse.filters ||
      lastResponse.detected_filters ||
      {};

    // 3. Convert array → object if needed
    //    Array form: [{ key: "person_titles", value: ["AI Engineer"] }, ...]
    let filtersFromAi = {};
    if (Array.isArray(rawFilters)) {
      rawFilters.forEach((f) => {
        const key = f.key || f.label;
        if (!key) return;
        const val = f.value;
        filtersFromAi[key] = Array.isArray(val) ? val : [val].filter(Boolean);
      });
    } else {
      filtersFromAi = rawFilters;
    }

    // 4. Build a readable prompt (for display / fallback)
    const parts = ["Get contacts for below criteria"];

    const titles = filtersFromAi.person_titles || filtersFromAi.jobTitle || filtersFromAi.titles;
    if (titles?.length) parts.push(`Titles: ${titles.join(", ")}`);

    const seniorities = filtersFromAi.person_seniorities || filtersFromAi.seniority || filtersFromAi.seniorities;
    if (seniorities?.length) parts.push(`Seniorities: ${seniorities.join(", ")}`);

    const locations =
      filtersFromAi.person_locations ||
      [
        ...(filtersFromAi.city || []),
        ...(filtersFromAi.state || []),
        ...(filtersFromAi.country || []),
      ];
    if (locations?.length) parts.push(`Location: ${locations.join(", ")}`);

    const skills = filtersFromAi.person_skills || filtersFromAi.skills;
    if (skills?.length) parts.push(`Skills: ${skills.join(", ")}`);

    const companySize =
      filtersFromAi.organization_num_employees_ranges ||
      filtersFromAi.companySize ||
      filtersFromAi.company_sizes;
    if (companySize) {
      parts.push(
        `Company Size: ${Array.isArray(companySize) ? companySize.join(", ") : companySize}`
      );
    }

    const prompt_ = parts.filter(Boolean).join("\n");

    // 5. Final payload
    const payload = {
      query: prompt_,
      session_id: sessionId,
      // provider: lastResponse.provider || "apollo",
      filters: filtersFromAi, // always a plain object now
    };

    console.log("Payload being encrypted =>", payload);

    // 6. Encrypt
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      "lm_data_param"
    ).toString();

    // 7. Keep session
    if (sessionId) {
      sessionStorage.setItem("ai_session_id", sessionId);
    }

    // 8. Close AI modal + navigate to the CORRECT route
    dispatch(setAiModal(false));
    navigate(`/contact-filter?data=${encodeURIComponent(encrypted)}`);
  };

  // endregion


  return (
    <div className='page-layout'>
      <AppNavbar />
      <div className="page-content">
        <div className="search-contact-filter-container-second-div" style={{ height: '100%' }}>
          <div
            ref={containerRef}
            className="container-fluid p-4"
            style={{ background: "#f6f7fb", height: "89vh", overflow: "auto" }}
          >
            <div
              className="card border-0 shadow-sm mb-4"
              style={{
                borderRadius: "24px",
                overflow: "hidden",
                background:
                  "linear-gradient(135deg, #4F0341 0%, #7B1E65 50%, #9C2780 100%)",
              }}
            >
              <div className="card-body p-4 text-white">
                <div className="d-flex justify-content-between align-items-start flex-wrap">
                  <div>
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <Sparkles size={22} />
                      <span
                        style={{
                          letterSpacing: "1px",
                          fontSize: "14px",
                          opacity: 0.9,
                        }}
                      >
                        LEADMERGE LLC AI SEARCH ENGINE
                      </span>
                    </div>

                    <h1
                      className="fw-bold mb-2"
                      style={{ fontSize: "42px" }}
                    >
                      {response.count?.toLocaleString()}
                    </h1>

                    <h5 className="mb-3 opacity-90">
                      Applied Filters
                    </h5>

                    <div className="d-flex gap-2 flex-wrap">
                      {filterApplied?.map((filter, index) => (
                        <span
                          key={index}
                          className="badge"
                          style={{
                            background: "rgba(255,255,255,0.18)",
                            padding: "10px 16px",
                            borderRadius: "30px",
                            fontSize: "13px",
                            fontWeight: "500",
                          }}
                        >
                          {filter.label}: {filter.value}
                        </span>
                      ))}
                    </div>
                  </div>

                  {countVal && <div
                    className="mt-3 mt-md-0"
                    style={{
                      background: "rgba(255,255,255,0.12)",
                      padding: "18px",
                      borderRadius: "20px",
                      minWidth: "240px",
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <Clock3 size={18} />
                      <span>Search Completed</span>
                    </div>

                    <h3 className="fw-bold mb-0 d-flex align-items-center">
                      <div
                        style={{
                          width: "26px",
                          height: "26px",
                          borderRadius: "10px",
                          background: "#F4ECF2",
                          color: "#4F0341",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Users size={16} />
                      </div>&nbsp;{countVal.toLocaleString()}
                    </h3>

                    <div className='ai-window-result'
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}>
                      <small className="opacity-75">
                        Total Counts
                      </small>
                      <small style={{
                        cursor: "pointer",
                        background: "#000",
                        borderRadius: "6px",
                        padding: "2px 8px"
                      }}
                        onClick={viewSearchResult}>View</small>
                    </div>
                  </div>}
                </div>
              </div>
            </div>
            {response.map((resp, index) => {
              const leads = resp?.results?.apollo || [];
              return (
                <div key={index}>
                  <div className="g-4 mb-1">
                    <SummaryCard
                      icon={<Clock3 size={20} />}
                      title="AI Processing Time"
                      value={resp.timeTaken}
                    />
                  </div>

                  {/* AI Explanation */}
                  {leads.length === 0 && <div
                    className="card border-0 shadow-sm mb-4"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex gap-3">
                        <div
                          style={{
                            width: "55px",
                            height: "55px",
                            borderRadius: "16px",
                            background: "#F4ECF2",
                            color: "#4F0341",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Sparkles size={24} />
                        </div>

                        <div>
                          <h5 className="fw-bold mb-2">
                            AI Recommendation
                          </h5>

                          <p
                            className="mb-0 text-muted"
                            style={{ lineHeight: "1.8" }}
                          >
                            {resp.explanation}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}

                  {leads.length > 0 &&
                    <div
                      className="card border-0 shadow-sm"
                      style={{ borderRadius: "24px" }}
                    >
                      <div className="card-body p-4">
                        {resp?.pagination?.apollo?.page === 1 && <div className="d-flex justify-content-between align-items-center mb-4">
                          <div>
                            <h4 className="fw-bold mb-1 text-start">
                              AI Lead Results
                            </h4>

                            <p className="text-muted mb-0">
                              Preview of matched contacts from AI search
                            </p>
                          </div>
                        </div>}

                        <div className="table-responsive">
                          <table className="table align-middle">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Title</th>
                                <th>Company</th>
                                <th>Country</th>
                                <th>Email</th>
                              </tr>
                            </thead>

                            <tbody>
                              {leads.map((lead, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="fw-semibold">
                                      {lead.name}
                                    </div>
                                  </td>

                                  <td>{lead.title}</td>

                                  <td>{lead.organization}</td>

                                  <td>{lead.country || "-"}</td>

                                  <td>
                                    {lead.email ? (
                                      <span
                                        className="badge"
                                        style={{
                                          background: "#E7F8EC",
                                          color: "#1E8E3E",
                                          padding: "8px 14px",
                                          borderRadius: "20px",
                                        }}
                                      >
                                        Available
                                      </span>
                                    ) : (
                                      <span
                                        className="badge bg-light text-dark"
                                        style={{
                                          padding: "8px 14px",
                                          borderRadius: "20px",
                                        }}
                                      >
                                        Not Available
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <button
                          className="btn btn-sm"
                          style={{
                            background: "#4F0341",
                            color: "white",
                            borderRadius: "10px",
                          }}

                          onClick={viewSearchResult}
                        >
                          View Result
                        </button>
                      </div>
                    </div>}
                </div>
              )
            })}

          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

const SummaryCard = ({ icon, title, value }) => {
  return (
    <div className="">
      <div
        className="card border-0 h-40"
        style={{ borderRadius: "20px", backgroundColor: "transparent", padding: "0" }}
      >
        <div className="card-body d-flex align-items-center gap-3 p-0">
          <div
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              background: "#F4ECF2",
              color: "#4F0341",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </div>

          <p className="text-muted mb-1">{title}:</p>
          <h6 className="fw-bold mb-0">{value}s</h6>
        </div>
      </div>
    </div>
  );
};

export default OpenAiPage
